import { TEMPO } from 'context/BrandContext';
import { getEnvConstants } from 'helpers/envConstants';

export const MILITARY_MEDICAL_TEACHER_SCOPES =
  'military,responder,nurse,medical,teacher,hospital_employee';
export const STUDENT_ALUMNI_GOV_SCOPES = 'student,alumni,government';

export const CARAWAY_PROMO_CODES = [
  'FBCRWYV0',
  'FBCRWYV1',
  'FBCRWYV2',
  'FBTSCRWYV0',
  'FBTSCRWYV1',
  'FBTSCRWYV2',
];

export const hasCarawayPromoCode = voucher => {
  if (!voucher || !voucher.code) return false;
  return CARAWAY_PROMO_CODES.includes(voucher.code.toUpperCase());
};

export const HEXCLAD_PROMO_CODES = ['FB499HEXCLAD', 'FB499GORDHEX'];

export const hasHexCladPromoCode = voucher => {
  if (!voucher || !voucher.code) return false;
  return HEXCLAD_PROMO_CODES.includes(voucher.code.toUpperCase());
};

export const hideIdMe = (voucher, user) => {
  if (!voucher || !voucher.code) return false;
  return (
    user?.isUsaa || voucher?.isGovX || hasCarawayPromoCode(voucher) || hasHexCladPromoCode(voucher)
  );
};

export const endpointFor = ({
  brand,
  scopes,
  account = false,
  billing = false,
  family = false,
  isPickYourMeals = false,
}) => {
  const origin = window.location.origin;
  const { IDME_CLIENT_ID } = getEnvConstants(brand);
  let redirectUri;

  if (account) {
    redirectUri = `${origin}/account/settings/billing`;
  } else if (billing) {
    if (family) {
      redirectUri = `${origin}/signup/billing/family`;
    } else if (brand === TEMPO) {
      if (isPickYourMeals) {
        redirectUri = `${origin}/pick-meals/billing/tempo`;
      } else {
        redirectUri = `${origin}/signup/billing/tempo`;
      }
    } else {
      redirectUri = `${origin}/signup/billing/standard`;
    }
  } else {
    if (family) {
      redirectUri = `${origin}/signup/promo/family`;
    } else if (brand === TEMPO) {
      redirectUri = `${origin}/signup/promo/tempo`;
    } else {
      redirectUri = `${origin}/signup/promo/standard`;
    }
  }

  return `https://groups.id.me/?client_id=${IDME_CLIENT_ID}&redirect_uri=${redirectUri}&response_type=token&scopes=${scopes}`;
};
